module.exports = __webpack_public_path__ + "img/del.59213afb.png";